SlideView  = require "views/slide"
{ DraggyView } = require("views/components/draggy")
SmoothLine = require("lib/draw/smooth-line")
Preloader = require("lib/preload")
{ dpi }    = require("lib/device")
Logger = new (require "lib/logger")(true, "Scratch to reveal", "#4defcc")

class ScratchToRevealView extends SlideView
  template: require("./template")

  events: ->
    "iostap .btn-done": "submit"
    "iostap .btn-replay": "restart"

  serialize: ->
    data = super
    data.before.contentType = "image"
    data

  beforeShow: ->
    images = @findAll("img")
    @setEl @findOne(".slider"), "slider"
    @setEl @findOne(".slider-knob"), "knob"
    @setEl @findAll(".slider-item"), "items"

    @draggy = null
    delete @draggy

    if images.length > 0
      Preloader.load _.pluck(images, "src"), => @sizeContent()
    else
      @sizeContent()

  restart: ->
    @points = []
    @setState("prompt")
    @sizeContent()

  show: ->
    @createDraggy()
    @points = []

  createDraggy: ->
    width = @getEl("slider").offsetWidth

    @draggy = new DraggyView
      el: @findOne(".slider-item-0 .multi-content-media")
      minX: 0
      maxX: width
      isParent: true

    @listenTo this, "resize", @onResize
    @listenTo @draggy, "drag", @onDrag
    @listenTo @draggy, "drop", @onDrop

  onResize: ->
    @sizeContent()
    for set in @points
      for point, i in set
        @draw(set.slice(i, i + 2))

  onDrag: (draggy, isInitial) ->
    @points.push [] if isInitial
    _.last(@points).push x: draggy.x * dpi * 2, y: draggy.y * dpi * 2
    @draw(_.last(@points).slice(-2))

  onDrop: ->
    { data } = @context.getImageData(
      0, 0
      @context.canvas.width, @context.canvas.height
    )

    alphaPixels = _.filter(data, (e, i) -> i % 4 is 3)
    @setState("touched") if _.average(alphaPixels) / 255 < 0.2

  draw: ([p1, p2]) ->
    retina = dpi * 2 # need to double the dpi for retina to not look blurry
    radius = 30 * retina

    p2   ?= p1
    diffX = p2.x - p1.x
    diffY = p2.y - p1.y
    diffM = Math.max(Math.abs(diffX), Math.abs(diffY), 1)
    @context.fillStyle = "#000"

    @context.beginPath()

    for i in [0..diffM]
      d = i / diffM
      x = p1.x + diffX * d
      y = p1.y + diffY * d
      @context.arc(x, y, radius, 0, Math.PI * 2)

    @context.fill()

    if _.chain(@points).pluck("length").sum().value() > 120
      @setState("touched")

  loadImage: (img) ->
    new Promise((resolve, reject) ->
      if img.complete
        Logger("Image loaded drawing now")
        resolve(img)
      else
        Logger("Image not ready yet, setting onload")
        img.onload = => resolve(img)
        img.onerror = => reject(new Error("Failed to load image: #{img.src}"))
    )

  sizeContent: ->
    @setState false, "sized"

    els        = @findAll(".multi-content-wrapper")
    labels     = @findOne(".slider-labels")
    img        = @findOne(".slider-item-0 img")
    canvas     = @findOne("canvas")
    slideTitle = @findOne(".slide-title")

    sliderParent = @getEl("slider").parentNode
    containerHeight = @el.offsetHeight
    retina = dpi * 2 # need to double the dpi for retina to not look blurry

    size = _.reduce els, (m, el) ->
      h: Math.max(m.h, el.offsetHeight)
      w: Math.max(m.w, el.offsetWidth)
    , { h: 80, w: 0}

    unless canvas
      canvas = document.createElement("canvas")
      canvas.style.position = "absolute"
      canvas.style.top    = "0"
      canvas.style.left   = "0"
      img.insertAdjacentElement("afterEnd", canvas)

    padding = parseFloat(window.getComputedStyle(img.parentNode).paddingLeft)
    cWidth  = img.parentNode.offsetWidth
    cHeight = Math.max(img.parentNode.offsetHeight, size.h - padding * 2)
    iWidth  = img.offsetWidth
    iHeight = img.offsetHeight

    canvas.style.width  = "#{cWidth}px"
    canvas.style.height = "#{cHeight}px"
    canvas.width  = cWidth * retina
    canvas.height = cHeight * retina

    @context = canvas.getContext("2d")
    img.crossOrigin = "Anonymous";

    @loadImage(img)
      .then (loadedImg) =>

        Logger("Clearing canvas")
        @context.clearRect(0, 0, canvas.width, canvas.height)
        
        Logger("Applying default canvas")
        @context.fillStyle = @options.data.canvasBackground or "white"
        @context.rect(0, 0, canvas.width, canvas.height)
        @context.fill()
        
        Logger("Drawing loaded image")
        @context.drawImage(
          loadedImg,
          (cWidth  - iWidth)  / 2 * retina,
          (cHeight - iHeight) / 2 * retina,
          iWidth * retina,
          iHeight * retina
        )
        
        # Set composite operation for future drawings
        @context.globalCompositeOperation = "destination-out"
        
      .catch (error) ->
        console.error(error)

    @getEl("slider").style.height = ""
    @getEl("slider").style.width  = ""

    @getEl("slider").style.height = "#{size.h}px"
    @getEl("slider").style.width  = "#{size.w}px"

    # Available space for labels after image and title are set
    availableSpace = containerHeight - sliderParent.offsetHeight - slideTitle.offsetHeight - 8 #8px for bottom padding

    height = _.reduce labels.children, (m, el) ->
      Math.min(Math.max(m, el.offsetHeight), availableSpace)
    , 0

    labels.style.height = "#{height}px"

    @setState true, "sized"

    if @draggy?
      @draggy.options.maxX = size.w
      @draggy.getOffset()

  onRefresh: ->
    @beforeShow()
    super

  refresh: (params) ->
    isAfter = not _.isEqual(params.data.after, @options.data.after)

    super

    if isAfter
      @setState("touched")

module.exports = ScratchToRevealView
